import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { HiringBanner } from "@/components/site/HiringBanner";
import { HowItWorks } from "@/components/site/HowItWorks";
import { OurPromise } from "@/components/site/OurPromise";
import { Ribbon } from "@/components/site/Ribbon";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { Payments } from "@/components/site/Payments";
import { QuoteForm } from "@/components/site/QuoteForm";
import { ServiceArea } from "@/components/site/ServiceArea";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { BottomBar } from "@/components/site/BottomBar";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <HiringBanner />
        <HowItWorks />
        <OurPromise />
        <Ribbon />
        <Services />
        <Manifesto />
        <About />
        <Payments />
        <QuoteForm />
        <ServiceArea />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
}
